import { apiClient } from '../utils/api';

export interface AnalyticsTrendPoint {
  day: string;
  queries: number;
  sessions: number;
  avgResponseTimeMs: number;
  tokens: number;
  costUsd: number;
}

export interface AnalyticsSourceDistribution {
  name: string;
  value: number;
}

export interface AnalyticsTopChatbot {
  id: string;
  name: string;
  queries: number;
}

export interface AnalyticsOverview {
  windowDays: number;
  kpis: {
    totalChatbots: number;
    activeChatbots: number;
    connectedSources: number;
    queriesToday: number;
    totalQueries: number;
    uniqueSessions: number;
    avgResponseTimeMs: number;
    totalTokens: number;
    totalCostUsd: number;
  };
  trends: AnalyticsTrendPoint[];
  sourceDistribution: AnalyticsSourceDistribution[];
  topChatbots: AnalyticsTopChatbot[];
  comparison?: {
    previousWindowDays: number;
    previousKpis: {
      totalQueries: number;
      uniqueSessions: number;
      avgResponseTimeMs: number;
      totalTokens: number;
      totalCostUsd: number;
      queriesToday: number;
    };
    currentWindow: {
      queriesToday: number;
    };
  } | null;
}

type ApiSuccess<T> = {
  success: boolean;
  data: T;
  message?: string;
  timestamp: string;
  statusCode: number;
};

class AnalyticsService {
  async getOverview(days = 30, compare = true): Promise<AnalyticsOverview> {
    const response = await apiClient.get<ApiSuccess<AnalyticsOverview>>(
      `/api/v1/analytics/overview?days=${days}&compare=${compare ? 'true' : 'false'}`
    );
    return response.data;
  }
}

const analyticsService = new AnalyticsService();
export default analyticsService;
